export default "__VITE_ASSET__Bcb4mj0R__"